import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { DeviceType } from '~/types/device-type'

import AppLogo from '~/components/AppLogo'

export interface ValueProps {
  device_type: DeviceType
  logo_url: string
}

const SmallAppIconCellRenderer = ({ value }: ICellRendererParams<unknown, ValueProps>): ReactElement => {
  if (!value) return <div />

  const { device_type, logo_url } = value

  return (
    <div className="app-icon-cell-renderer-component">
      <AppLogo appLogoUrl={logo_url} appPlatform={device_type} size="small" />
    </div>
  )
}

export default SmallAppIconCellRenderer
